import SelectLocale from './SelectLocale';

export default SelectLocale;



// WEBPACK FOOTER //
// ./src/components/SelectLocale/index.js